var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"font-montserrat text-wrap break-word login-slogan-text font-weight-black normal-line-height white--text px-12 mx-5 py-7",attrs:{"flat":"","tile":"","color":"transparent","width":"370"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.sloganText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }